import * as React from 'react';
import clsx from "clsx";
import customStyles from "../../assets/styles/customStyles";
import MainHeader from "../Shared/components/Header";
import { Navbar } from "../Shared/components/Header/Navbar";
import SettingsImg from "../../assets/images/icon_menus/SettingsIcon.json";

export const NoMatch = (props) => {
    const classes = customStyles();
    return (
        <React.Fragment>
            <Navbar {...props} />
            <MainHeader {...props}
                NoMatch={true} img={SettingsImg} title={'404 Page'}
                links={[{ 'label': 'Home', 'link': '/' }, { 'label': 'Page Not Found', 'link': '' }]} />            
            <div className={clsx(classes.margin40, classes.listTableMargin, classes.Error404)}>
                404 Not Found
            </div>
        </React.Fragment>
    )
}